module.exports = __webpack_public_path__ + "img/73.a1cd3cea.jpg";